<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="https://www.sports4me.at/datenschutz/">Datenschutz</a>
          </li>
          <li>
            <a href="https://www.sports4me.at/impressum/">Impressum</a>
          </li>
          <li>
            <a href="https://www.sports4me.at/faq/">FAQ</a>
          </li>
          <li>
            <a href="https://www.sports4me.at/anmeldeprozess/">Anmeldeprozess</a>
          </li>
          <li>
            <router-link to="/contact">Kontakt</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://www.sports4me.at/" target="_blank">Sports4me GmbH</a>
      </div>
    </div>
    <cookie-law theme="royal">
    <div slot-scope="props">
    <p>
    Diese Internetseite verwendet Cookies und Google Analytics für die Analyse und Statistik. Wir nutzen Cookies zu unterschiedlichen Zwecken, unter anderem zur Analyse und für personalisierte Marketing-Mitteilungen. Durch die weitere Nutzung der Website stimmen Sie der Verwendung zu. Weitere Informationen hierzu finden Sie in unserer
    <a href="https://www.sports4me.at/datenschutz/">Datenschutzbestimmungen</a>.
    </p>
    <md-button  @click="props.accept" class="md-success">Einverstanden</md-button>
    <md-button  @click="props.close">Ablehnen</md-button>
    </div>
    </cookie-law>
  </footer>
</template>
<script>
import CookieLaw from 'vue-cookie-law';
export default {
  components: {
    CookieLaw
  }
};
</script>
<style></style>
